import breadcrumbConstants from '../breadcrumb.constants';

export const updateBreadcrumb = params => (dispatch) => {
  dispatch({
    type: breadcrumbConstants.UPDATE_BREADCRUMB,
    params
  });
};
